import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profit-margin-maye-preview',
  templateUrl: './profit-margin-maye-preview.component.html',
  styleUrls: ['./profit-margin-maye-preview.component.scss']
})
export class ProfitMarginMayePreviewComponent {
  @Input() data: any = null;
  tab = 0;

  columns = [
    { key: 'warehouseName', label: 'Bodega', align: 'start' },
    { key: 'productName', label: 'Producto', align: 'start' },
    { key: 'quantity', label: 'Unidades vendidas', align: 'end', format: 'int' },
    { key: 'totalSalePrice', label: 'Ingreso', align: 'end', format: 'money' },
    { key: 'totalCost', label: 'Costo ventas', align: 'end', format: 'money4' },
    { key: 'grossMargin', label: 'Utilidad bruta', align: 'end', format: 'money4' },
    { key: 'grossMarginPercent', label: '% utilidad bruta', align: 'end', format: 'percent' }
  ];

}
